export default __webpack_public_path__ + "static/media/affligem_background_l1.c4bb35f3.jpg";